import Phaser from "phaser";
import { SuikaScene } from "./scenes/SuikaScene";
import "./style.css";

const isPhonePortrait = window.matchMedia("(orientation: portrait) and (max-width: 700px)").matches;
const gameWidth = isPhonePortrait ? 520 : 960;
const gameHeight = isPhonePortrait ? 900 : 720;

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "app",
  width: gameWidth,
  height: gameHeight,
  backgroundColor: "#f5efe5",
  physics: {
    default: "matter",
    matter: {
      gravity: { x: 0, y: 1.15 },
      enableSleeping: true,
      debug: false
    }
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: gameWidth,
    height: gameHeight
  },
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false
  },
  input: {
    activePointers: 3
  },
  scene: [SuikaScene]
};

new Phaser.Game(config);
